// Slice RTK per `state.driverWarnings` = `{ list, loading, error }`.
// Variante con stato di loading e gestione errori (fetch via HTTP + listener
// per added/modified/removed via Firestore).

import { createSlice } from '@reduxjs/toolkit';

const initialState = { list: [], loading: false, error: null };

const driverWarningsSlice = createSlice({
  name: 'driverWarnings',
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload ?? [];
      state.error = null;
    },
    fetchFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload ?? null;
    },
    added: (state, action) => {
      const w = action.payload;
      if (!state.list.some((x) => x.id === w.id)) state.list.push(w);
    },
    modified: (state, action) => {
      const w = action.payload;
      const i = state.list.findIndex((x) => x.id === w.id);
      if (i !== -1) state.list[i] = w;
    },
    removed: (state, action) => {
      state.list = state.list.filter((x) => x.id !== action.payload);
    },
  },
});

export const driverWarningsActions = driverWarningsSlice.actions;
export default driverWarningsSlice.reducer;
